import { createSlice } from "@reduxjs/toolkit";
import { searchImagingTests } from "../../reducer/searchImagingTests/searchImagingTestsReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const searchImagingTestsSlice = createSlice({
  name: "searchImagingTests",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(searchImagingTests.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchImagingTests.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(searchImagingTests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default searchImagingTestsSlice.reducer;
